var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadMediaIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download_14px",
    transform: "translate(-992 -320)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_829",
    "data-name": "Rectangle 829",
    width: 14,
    height: 14,
    transform: "translate(992 320)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "download-outline",
    transform: "translate(898.018 272.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M103.474,176h1.246a1.246,1.246,0,0,1,1.246,1.246v6.477a1.246,1.246,0,0,1-1.246,1.246H97.246A1.246,1.246,0,0,1,96,183.723v-6.477A1.246,1.246,0,0,1,97.246,176h1.246",
    transform: "translate(0 -124.014)",
    fill: "none",
    stroke: "#5f636b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M176,54.976l2.491,2.491,2.491-2.491M178.491,48v8.969",
    transform: "translate(-77.509)",
    fill: "none",
    stroke: "#5f636b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadMediaIcon);
export default __webpack_public_path__ + "static/media/download-media-icon.5bec76811c83c9033f9a16c726329d1c.svg";
export { ForwardRef as ReactComponent };